// extracted by mini-css-extract-plugin
module.exports = {"ContentContainerInner":"ConversationsPage_ContentContainerInner__14kjx","Conversations":"ConversationsPage_Conversations__3EoBu","SideNav":"ConversationsPage_SideNav__377qM"};